<template>
  <div class="animated fadeIn">
    <basic-heading title="New Lab Instrument" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add instrument instance'">
      <template #gated-content>
        <instrument-instance-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import InstrumentInstanceForm from "@/components/lab/instrumentinstance/InstrumentInstanceForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { notificationOptions } from "@/shared/toast-notification-options";
import { instrumentInstanceNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

Vue.use(VueNotifications, notificationOptions);

const InstrumentInstanceRepository =
  LabRepositoryFactory.get("instrumentInstance");

export default {
  name: "InstrumentInstanceAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    InstrumentInstanceForm,
    PermissionAlertGate,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/instrument-instances",
            title: "Lab Instrument list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      const payload = { ...form_data };

      delete payload.priority;

      try {
        const { data } = await InstrumentInstanceRepository.create(payload);

        this.addSuccess();

        this.$router.push(`/instrument-instances/${data.id}`);
      } catch ({ response }) {
        const { data, status } = response;
        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Lab Instrument Creation failed.",
          variant: "danger",
        });
      }
    },
  },
  notifications: instrumentInstanceNotifications,
};
</script>
